import { useMutation, useQueryClient } from "@tanstack/react-query";
import { REGISTER } from "../../api/Api";
import SubmitAction from "../../components/Auth/Sign/SubmitAction";
import Logo from "../../components/Logo";
import FooterDetails from "../../layout/FooterDetails";
import { SignSchema } from "../../Validations/SignSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRef } from "react";
import Cookie from "cookie-universal";
import { useForm } from "react-hook-form";
import { duplicateEmailMess, duplicateNameMess } from "../../Validations/BaseSchema";
import { useAuth } from "../../context/AuthContext";
import { useOpenField } from "../../Store/MenuSlice";
import { useNavigate } from "react-router-dom";
import { Axios } from "../../Axios/createAxios";
export default function Register() {
  const { checkAuth } = useAuth();
  const queryClient = useQueryClient();
  const cookie = Cookie();
  const formRef = useRef({});
  const schema = SignSchema(formRef.current);
  const openField = useOpenField();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const form = watch();
  console.log(form);

  const data = async () => {
    try {
      const res = await Axios.post(`/${REGISTER}`, form);
      console.log(res);

      return res;
    } catch (err) {
      console.log(err);

      throw err?.response?.data?.errors;
    }
  };

  const { mutate, isLoading, isSuccess } = useMutation({
    mutationFn: data,

    onSuccess: (data) => {
      reset();
      navigate("/");
      openField("isVerified");
      const ex = Date.now() + 60000;
      localStorage.setItem("expireTime", ex.toString());
      const token = data.data.token;
      if (token) {
        cookie.set("bearer", token);
        checkAuth();
      }
      console.log(data);
      queryClient.invalidateQueries("profile");
    },
    onError: (err) => {
      console.log(err);

      if (err.email) {
        formRef.current.email = getValues("email");
        setError("email", { type: "server", message: duplicateEmailMess });
      }
      if (err.name) {
        setError("name", { type: "server", message: duplicateNameMess });
        formRef.current.name = getValues("name");
      }
      console.log(formRef.current);
    },
  });
  const errorMessage = errors ? Object.values(errors)[0]?.message : "";

  const onSubmit = (data) => {
    if (isLoading) return;

    mutate(data);
  };

  return (
    <>
      <div className="container page-h d-flex flex-center align-items-center sign">
        <div className="form-container d-flex  w-50 flex-center flex-column align-items-center justify-content-between p-15 box-shadow">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="d-flex flex-column justify-content-between gap-15 sign-form">
            <div className="input-container gap-30 align-items-center">
              <Logo />
              <p className="pl-5 pr-5 w-full txt-center">
                If in trouble, we're here to help. If you have solutions, we need your assistance
              </p>

              <input placeholder="email" type="text" {...register("email")} />
              <input placeholder="user name" {...register("name")} type="text" />
              <input type="password" name="password" placeholder="Password" {...register("password")} />

              <input type="password" placeholder="Password Confirm" {...register("password_confirmation")} />
            </div>
            <p style={{ textAlign: "center" }}>{errorMessage}</p>
            <SubmitAction isLoading={isLoading} submit={"Sign Up"} href={"/login"} hrefText={"Log In"} />
          </form>
        </div>
      </div>

      <FooterDetails />
    </>
  );
}
